import { render, staticRenderFns } from "./revote.vue?vue&type=template&id=488370ce"
import script from "./revote.vue?vue&type=script&lang=js"
export * from "./revote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports